enum EApiAuth {
  userInfo = '/auth/userinfo',
}

export default EApiAuth;
